// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flight-data-form .el-form--inline {\n  display: flex;\n  justify-content: space-between;\n}", ""]);
// Exports
module.exports = exports;
